import type { IDrawRequest } from 'pages/Borrower'
import { DrawRequestStatusBadge } from 'pages/Borrower/DrawRequest/drawRequestStatus'
import { Modal, PlainTable } from 'stories/components'
import { formatTime, getPrice2decimal, replaceNextLineToBr } from 'utils'

import { drawRequestForLine } from './drawRequestLine'

export const DrawRequestsDialog = ({
  value,
  title,
  lineValue,
  lineKey,
  requests,
  onClose,
}: {
  value: string
  title: string
  /** The budget line this dialog was opened on: its section's `value` and the cell's key. */
  lineValue: string
  lineKey: string
  requests: IDrawRequest[]
  onClose: Function
}) => {
  return (
    <Modal isOpen titleOkay="" title="Draw Requests" onClose={() => onClose()}>
      <div className="w-196">
        <p className="mb-4">
          Description:{' '}
          <span className="font-semibold">
            {value} / {title}
          </span>
        </p>
        <PlainTable
          header={['No', 'Name', 'Amount', 'Description', 'Requested At', 'Status']}
          data={requests.map((v, index) => {
            const line = drawRequestForLine(v, lineValue, lineKey)
            // A budget modification moves no money: it shows this line's figure as it was and as the
            // borrower revised it, and the work they revised it to.
            const isModification = v.requestType === 'budgetModification'
            const revised = v.budgetRevision?.lines?.find((item) => item.value === lineValue && item.key === lineKey)
            const amountCell = isModification
              ? revised
                ? `$${getPrice2decimal(revised.originalAmount)} to $${getPrice2decimal(revised.revisedAmount)}`
                : '-'
              : `$${getPrice2decimal(line.amount)}`
            const description = isModification ? revised?.revisedWork || '' : line.description
            return [
              index + 1,
              [`${v.firstName} ${v.lastName}`.trim(), isModification ? '(budget modification)' : ''].join(' ').trim(),
              amountCell,
              <p dangerouslySetInnerHTML={{ __html: replaceNextLineToBr(description) }} />,
              formatTime(v.createdAt),
              <DrawRequestStatusBadge request={v} />,
            ]
          })}
        />
      </div>
    </Modal>
  )
}
